import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";

export const ModerationBlockedDialog = ({ block, onClose }) => (
  <Dialog open={!!block} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="bg-[#0A0A0A] border-[#FF3B30]/50 rounded-sm max-w-lg" data-testid="moderation-blocked-dialog">
      <DialogHeader>
        <DialogTitle className="font-heading tracking-tight flex items-center gap-2">
          <ShieldAlert className="w-5 h-5 text-[#FF3B30]" /> Message blocked — not sent
        </DialogTitle>
        <DialogDescription>
          Your message triggered {block?.flags?.length === 1 ? "a moderation flag" : `${block?.flags?.length} moderation flags`} and
          was not delivered. Edit the wording and try again.
        </DialogDescription>
      </DialogHeader>
      <ul className="space-y-3 py-1" data-testid="moderation-blocked-flags">
        {block?.flags?.map((f, i) => (
          <li key={i} className="border border-border bg-background rounded-sm p-3" data-testid={`blocked-flag-${i}`}>
            <p className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#FFCC00]">{f.category}</p>
            <p className="text-sm font-semibold mt-0.5">{f.name}</p>
            <p className="text-xs text-muted-foreground mt-1 leading-relaxed">{f.description}</p>
            {f.reason && <p className="text-xs text-white/80 mt-2 italic">“{f.reason}”</p>}
          </li>
        ))}
      </ul>
      <p className="text-xs text-muted-foreground leading-relaxed" data-testid="moderation-transparency-note">
        As per our transparency mandate, this attempt was logged with the flag type and forwarded to the site
        administrator for review. Messages that demonstrate malice may result in a strike on your account.
      </p>
      <DialogFooter>
        <Button onClick={onClose} data-testid="moderation-blocked-close" className="rounded-sm bg-[#007AFF] hover:bg-[#0066d6] text-white">
          Edit my message
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
